<template>
  <div
    ref="pride_tab_fixed"
    class="header-container"
    :class="{
      // 'header-home': page == '首页' || !isFixed,
      'header-default': page == '首页' || page !== '首页' || isFixed
    }"
  >
    <div class="head-logo">
      <a href="/index.html">
        <img v-if="isFixed || page == '首页'" :src="headerBg" />
        <img v-else :src="logoUrl" alt="" />
      </a>
    </div>
    <div class="nav-list">
      <div
        class="nav-item"
        :class="pages == item.nav_name ? 'nav-active' : ''"
        v-for="item in showNavList"
        :key="item.id"
        @click="handleMenuClick(item)"
      >
        <a :href="item.target_url" :target="item.target_type == 1 ? '_blank' : '_self'">
          {{ item.nav_name }}
        </a>
        <div class="bottom-line"></div>
      </div>
      <el-dropdown v-if="hideNavList.length > 0" popper-class="hidemenu_drop">
        <div class="nav-item item-hide">
          <a>
            <el-icon class="more_icon">
              <MoreFilled />
            </el-icon>
          </a>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item v-for="hideItem in hideNavList" :key="hideItem.id">
              <a
                :href="hideItem.target_url"
                class="noticenav"
                :target="hideItem.target_type ? '_blank' : '_self'"
              >
                {{ hideItem.nav_name }}
              </a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <div class="head-btn">
      <el-popover
        popper-class="workbench-popper"
        :show-arrow="false"
        :offset="12"
        :width="328"
        placement="bottom-end"
      >
        <template #reference>
          <div class="workbench" v-if="false">
            <img
              v-if="isFixed || page != '首页'"
              src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/be58dd0e0cf14ca29324989fc7391fcb.png"
            />
            <img
              v-else
              src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/2764788bf35d4da28898504c38b3a144.png"
            />
            <span>工作台</span>
          </div>
        </template>
        <div class="workbench-content">
          <div class="userole-troggle" @click="toggleShowRole()">
            <span>{{ userRoleList[currentRole] }}</span>
            <img
              v-if="userRole < 3 && userRole > 0"
              src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/02775dce51e34208bc0c1071c4b95229.png"
            />
            <!-- <el-popover
            popper-class="user-role-popper"
            >
              <template #reference>
                <div class="toggle-btn">
                  <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/02775dce51e34208bc0c1071c4b95229.png"/>
                </div>
              </template>
              <div class="user-role-list">
                <div class="user-role-item" v-for="(item, index) in roleList" :key="index" @click="toggleZhsRole(item)">{{ item.name }}</div>
              </div>
            </el-popover> -->
          </div>
          <div class="workbench-top">
            <div class="user-info">
              <div>您好,</div>
              <div>
                {{ userInfo && userInfo.realname }}
                <span v-if="userRole > 1">{{ userNameList[userRole] }}</span>
              </div>
            </div>
            <div class="main-btn" @click="handleOpenUrl(onlineUrl)">
              <span>AI教学中心</span>
              <img
                src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/a2b5328c56e5495397e6d2e540e8cf83.png"
              />
            </div>
          </div>
          <div class="workbench-bottom">
            <div
              v-for="(item, index) in menuList"
              class="workbench-item"
              @click="handleOpenUrl(item.jump_url)"
            >
              <img :src="item.icon_url" />
              <span>{{ item.app_name }}</span>
            </div>
          </div>
        </div>
      </el-popover>
      <!-- 未登录时 -->
      <div v-if="!userInfo" class="head-login">
        <a :href="getLoginUrl()" referrerPolicy="no-referrer">
          <img :src="require('../../assets/images/user_avatar.jpg')" alt="" />
        </a>
      </div>
      <!-- 登录时 -->
      <div v-if="userInfo" class="head-user">
        <el-popover
          popper-class="user-info-popper"
          placement="bottom-end"
          :offset="12"
          :width="212"
          :show-arrow="false"
        >
          <template #reference>
            <div class="avatar-box">
              <img
                class="avatar"
                :src="
                  userInfo.avatar ? userInfo.avatar : require('../../assets/images/user_icon.png')
                "
              />
            </div>
          </template>
          <div class="menu-btn">
            <div class="menu-btn-item" @click="goAdminPage">
              <div class="icon icon-admin"></div>
              <span>管理后台</span>
            </div>
            <div class="split-line"></div>
            <div class="menu-btn-item" @click="goAccountSet">
              <div class="icon icon-account"></div>
              <span>账号设置</span>
            </div>
          </div>
          <div class="menu-bottom-btn" @click="handleExit">退出登录</div>
        </el-popover>
      </div>
    </div>
  </div>
  <!-- 返回顶部 -->
  <!-- <div class="fixPostion">
    <div class="item">
      <div id="hannanuHelper"></div>
      <img class="icon icon-big" src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/f7921f2a47104f2a850439e6d033a7d6.png"/>
      <div class="text">AI助手</div>
    </div>
    <div class="item js-service-support">
      <img class="icon" src="https://image.zhihuishu.com/zhs/b2cm/base1/202504/438dcb2a67bb4493a1d21ba125087f65.png"/>
      <div class="text">联系客服</div>
    </div>
    <div class="item" @click="backTop">
      <img class="icon" src="https://image.zhihuishu.com/zhs/b2cm/base1/202504/774287ba7530458b9a3c133c33895b69.png"/>
      <div class="text">置顶</div>
    </div>
  </div> -->
</template>
<script>
import { getStorage } from '@/plugins/store'
import { handleLogin, handleLogout, getUrlParams, getLoginUrl } from '@/plugins/utils'
import { MoreFilled } from '@element-plus/icons-vue'
export default {
  components: {
    MoreFilled
  },
  props: {
    menuInfo: {
      type: Object
    },
    page: {
      type: String,
      default: ''
    },
    searchText: String,
    menuCode: String || Number
  },
  created() {
    this.getObjectStatus()
    this.getUserInfo()
  },
  mounted() {
    this.getBaseSet()
    this.addPv()
    this.titleFixed = false
    window.addEventListener('scroll', this.handleScroll, true)
    // this.initZhsHelper()
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      keyword: this.searchText,
      userInfo: null,
      teacherMenu: {},
      logoUrl: '',
      navList: [],
      headerBg: '',
      url: location.href.substring(location.href.indexOf('?') + 1),
      centerList: [],
      headList: [],
      onlineTeache: null,
      userRole: 0,
      zhsRole: 0,
      linkNav: [], // 导航中的外部链接
      showLogin: false,
      backUrl: `${window.location.origin}/admin/`,
      titleFixed: false,
      isLogin: false, //是否登录
      isFixed: false,
      userRoleList: ['未认证', '管理员', '老师', '学生'],
      userNameList: ['', '管理员', '老师', '同学'],
      roleList: [],
      currentRole: 3,
      menuList: [
        {
          name: '数据中心',
          path: 'https://dch5.zhihuishu.com/newDataCenter.html#/dataOverview?sid=1204',
          icon: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/97e7534dc0e5446599974cd3eea160ad.png'
        },
        {
          name: '督导系统',
          path: 'https://hainanuxkdd.zhihuishu.com',
          icon: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/7737f4fd89c04e2a8b63d98d46548beb.png'
        },
        {
          name: '课程智能体',
          path: '',
          icon: 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/9dffcd11fbdb4d5d8390da6b49fd097f.png'
        }
      ],
      pages: '',
      onlineUrl: '',
      school_id: 100
    }
  },
  computed: {
    CurrentUrl() {
      return this.page || window.location.href
    },
    showNavList() {
      return this.navList.slice(0, this.school_id == 795 ? 9 : 8)
    },
    hideNavList() {
      return this.navList.slice(this.school_id == 795 ? 9 : 8)
    },
    filteredNavList() {
      // 未登录状态：隐藏 function_id 为 18100 的项（智播课堂）
      // 已登录状态：显示所有项
      return this.showNavList.filter(item => {
        // 未登录时，排除 function_id=18100 的项
        if (!this.userInfo && item.function_id === '18100') {
          return false // 不显示
        }
        // 其他情况（已登录，或不是目标项）都显示
        return true
      })
    }
  },
  methods: {
    getLoginUrl,
    async getAppList(e) {
      const params = {
        role_type: e
      }
      const data = await this.$http.getAppList(params)
      this.menuList = data.filter(item => item.app_name != 'zhs_dz_platform')
      this.onlineUrl = data.find(item => item.app_name == 'zhs_dz_platform').jump_url
    },
    getUrlParams,
    toggleZhsRole(data) {
      this.currentRole = data.role
    },
    toggleShowRole() {
      if (this.userRole == 0 || this.userRole == 3) {
        return
      }
      const index = this.roleList.findIndex(item => item.role === this.currentRole)
      if (index < this.roleList.length - 1) {
        this.currentRole = this.roleList[index + 1].role
      } else {
        this.currentRole = this.roleList[0].role
      }
      // this.getAppList(this.currentRole)
    },
    handleLogin,
    async handleExit() {
      const res = await this.$http.getSingleLogoutUrl()
      handleLogout(res || '')
    },
    // 关键字搜索
    handleSearch() {
      if (this.keyword) {
        window.location.href = `/search.html?keyword=${this.keyword}`
      }
    },
    // 获取用户信息
    async getUserInfo() {
      let token = this.$utils.getCookie('X-Access-Token')
      // token登陆
      if (token) {
        // let test = {
        //   authorityList:null,
        //   avatar:"https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/zhspms/9eded7f9bde2433a9f833db08a10692c.gif",
        //   id:"4001",
        //   realname:"demo002",
        //   roleId:"4001",
        //   roleList:["4001"],
        //   uuid:"X2K8Klvp"
        // }
        // this.userInfo = test

        const userInfo = await this.$http.getUserInfo()
        this.userInfo = userInfo
      }

      if (this.userInfo) {
        // this.userInfo.uuid = "VJ77z84b";
        if (this.userInfo.uuid) {
          // this.getUserZhsRole()
          this.getUserIdentity()
        } else {
          this.getNavList()
        }
        this.isLogin = true
        this.$emit('getUserInfo', this.userInfo)
        this.$emit('update:isLogin', true) //已登录
      } else {
        this.getNavList()
        this.isLogin = false
        this.$emit('update:isLogin', false) //未登录
      }
    },
    // 获取用户智慧树角色
    async getUserIdentity() {
      let params = {
        schoolId: this.$schoolId,
        uuid: this.userInfo.uuid
      }
      const res = await this.$http.getUserIdentity(params)
      // 	0:未认证 1:管理者 2:老师 3:学生
      console.log('智慧树角色', res)
      this.userRole = res || 0
      if (res) {
        this.zhsRole = res || 0
        this.currentRole = this.zhsRole
        // this.getAppList(this.currentRole)
        if (this.zhsRole == 1) {
          this.roleList = [
            { name: '管理员', role: 1 },
            { name: '教师', role: 2 },
            { name: '学生', role: 3 }
          ]
        } else if (this.zhsRole == 2) {
          this.roleList = [
            { name: '教师', role: 2 },
            { name: '学生', role: 3 }
          ]
        }
      }
      this.$emit('userRole', this.userRole)
      this.getNavList()
    },
    // 获取用户智慧树权限
    async getUserZhsRole() {
      const res = await this.$http.getUserZhsIdentity({
        uuid: this.userInfo.uuid
      })
      //  role = 2 有数据中心权限，role=0 虽然有myuni权限，但是没有数据中心权限 role = 1 数据中心权限、教学指挥中心权限,
      console.log('智慧树权限', res)
    },
    async getNavList() {
      // 0：所有人可见；1：管理员可见；2：老师可见；3：学生可见
      const navlist = await this.$http.getNavList({
        roleType: this.userRole
      }) // 导航
      const functionList = await this.$http.getObjectOpen() // 项目已开启功能
      // 菜单显示权限处理
      sessionStorage.setItem('authInfo', JSON.stringify(navlist)) // 详情页判断登录用

      this.centerList = functionList.filter(item => item.target_type == '1')
      // 是否有登录按钮
      this.showLogin = functionList.some(item => item.code == '10000')
      // 账号设置页用到
      // this.teacherMenuId = navlist.map(item => (item.function_id == '10501' ? item.id : ''))
      // 外部链接列表
      this.linkNav = navlist.filter(item => item.target_page == 1)

      // 路由集合
      const urlList = {
        10301: '/index.html?',
        10401: '/courseList.html?type=1&',
        10402: '/courseList.html?type=2&',
        10501: '/teacherList.html?',
        10601: '/live.html?',
        10701: '/notice.html?',
        51001: '/teachingCenterList.html?',
        13100: '/microSpecialtyList.html?',
        40005: '/lectureList.html?',
        13200: '/virtual.html?',
        11020: '/train.html?',
        11021: '/courseOutline.html?',
        51007: '/courseGroupList.html?',
        18100: '/wonderfulClass.html?',
        51006: '/researchCourseList.html?'
      }

      // 点击导航跳转到对应taget_url,并传参
      // 重新组装数据
      const data = navlist.map(item => {
        item.childs = item.childs
          ? item.childs.map(child => {
              return {
                ...child,
                target_url:
                  child.target_page == 1
                    ? child.target_url
                    : `${urlList[child.function_id]}menuId=${child.menu_id}&name=${
                        child.nav_name
                      }&roleType=${child.roleType}`
              }
            })
          : item.childs
        return {
          ...item,
          target_url:
            item.target_page == 1
              ? item.target_url
              : `${urlList[item.function_id]}menuId=${item.menu_id}&name=${item.nav_name}`
        }
      })

      // 获取过滤后的最终的nav列表
      this.navList = !this.userInfo ? data.filter(item => item.auth_type !== 3) : data

      this.$emit('getNavList', this.navList)

      // 详情页是否需要登录
      const authInfo = data.find(
        item =>
          item.function_id == this.menuCode && item.menu_id == this.$utils.getUrlParams('menuId')
      )
      if (authInfo && authInfo.auth_type == 2 && !this.userInfo) {
        // 修改登录逻辑
        this.handleLogin(true)
      }

      // 当前页面 导航高亮
      let currentPageIndex = 0
      if (this.$utils.getUrlParams('menuId'))
        currentPageIndex = (this.navList || []).findIndex(
          item => item.menu_id == this.$utils.getUrlParams('menuId')
        )
      if (this.navList[currentPageIndex]) {
        // this.page = this.navList[currentPageIndex].nav_name
        this.pages = this.navList[currentPageIndex].nav_name
        this.$emit('update:menuInfo', this.navList[currentPageIndex])
      }

      // 头部指挥中心等按钮展示规则
      if (this.linkNav.length) {
        const arr = this.linkNav.map(item => item.function_id)
        this.headList = this.centerList.filter(
          item => !arr.includes(item.code) && item.code !== '16001'
        )
        this.onlineTeache = this.centerList.find(item => item.code == '16001')
      }
    },
    // 基础配置信息
    async getBaseSet() {
      const res = getStorage('projectBaseData') || {}
      this.logoUrl = res.home_logo_url || require('../../assets/images/home_logo.png')
      this.headerBg = res.home_head_bg_url || ''
      this.school_id = res.school_id
    },
    // 访问量
    async addPv() {
      let params = {
        clickEnum: 'PAGE',
        loginUserId: this.userInfo ? this.userInfo.id : undefined
      }
      const res = await this.$http.saveBrowseClick(params)
    },
    // 项目状态
    async getObjectStatus() {
      const res = await this.$http.getObjectStatus()
      if (res.status == false) {
        window.location.href = '/stop.html'
      }
    },
    goAccountSet() {
      window.location.href = `/setting.html`
    },
    goAdminPage() {
      window.location.href = `/admin`
    },
    // 返回顶部
    backTop() {
      let timer = setInterval(() => {
        let ispeed = Math.floor(-this.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop + ispeed
        if (this.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 20)
    },
    handleScroll() {
      const header = document.querySelector('.header-container')
      const scrollPosition = window.scrollY
      if (scrollPosition > 80) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
      let scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrollTop = scrollTop
      let offsetTop = this.$refs.pride_tab_fixed.getBoundingClientRect().top
      this.titleFixed = offsetTop < 0
      console.log('offsetTop', this.isFixed, this.titleFixed)
    },
    handleOpenUrl(url) {
      window.open(url)
    },
    loadJs(src, flag = false) {
      return new Promise((resolve, reject) => {
        // 判断当前页面是否存在这个标签 存在就不创建
        let script = document.querySelector(`[src='${src}']`)
        if (script) {
          script.addEventListener('load', () => {
            resolve(null)
          })
        } else {
          script = document.createElement('script')
          script.type = 'text/javascript'
          if (flag) {
            script.id = 'zhs_tool_chat'
            script.setAttribute('elementZHsId', 'hannanuHelper')
            script.setAttribute('version', '1.0.0')
          }
          script.src = src
          document.querySelectorAll('head')[0].append(script)

          script.addEventListener('load', () => {
            resolve(null)
          })
          script.addEventListener('error', () => {
            reject()
          })
        }
      })
    },
    async initZhsHelper() {
      await this.loadJs('https://resources.polymas.com/common/loadVuePluginNpm.js', true)
      await this.loadJs(
        'https://base1.zhihuishu.com/able-commons/resources/uploader/client/js/jquery/jquery-1.7.2.min.js'
      )
      await this.loadJs('https://www.zhihuishu.com/scripts/common/onlineService.js')
      this.zhsHelper = new ZhsAiToolHelperCommon('3x99dFEe20', {
        //ip样式配置
        ipStyles: {
          //自定义助手对话框主题色
          mainColor: '#114e2d',
          //自定义助手ip形象
          toolIpIcon:
            'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/f7921f2a47104f2a850439e6d033a7d6.png',
          toolIpIconStyle: {
            top: '2rem',
            left: '0px',
            zIndex: 10000,
            width: '4rem',
            position: 'absolute'
          },
          //自定义对话框助手ip 形象
          ipIcon:
            'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/f7921f2a47104f2a850439e6d033a7d6.png',
          ipIconStyle: {
            width: '92px',
            right: '20px',
            marginBottom: '-20px'
          }
        },
        //禁止拖拽(不传默认false)
        disDrag: true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.header-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 40px;
  &.header-home {
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(15px);
    .nav-list {
      .nav-item {
        position: relative;
        font-weight: 400;
        &.item-hide {
          margin-right: 0;
        }
        &.nav-active,
        &:hover {
          font-weight: 500;
          .bottom-line {
            width: 100%;
          }
        }
        a {
          color: #ffffff;
        }
        .bottom-line {
          height: 2px;
          width: 0;
          background-color: #ffffff;
          position: absolute;
          bottom: -19px;
          left: 50%;
          transform: translateX(-50%);
          transition: all 0.3s;
        }
      }
    }
    .head-btn {
      .workbench {
        color: #ffffff;
        margin-right: 40px;
        display: flex;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
          margin-right: 4px;
        }
      }
      .head-login {
        cursor: pointer;
        a {
          color: #ffffff;
          img {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
  }
  &.header-default {
    color: #1d2129;
    background-color: #ffffff;
    border-bottom: 1px solid rgba(29, 33, 41, 0.08);
    .nav-list {
      .nav-item {
        &.item-hide {
          margin-right: 0;
        }
        &.nav-active,
        &:hover {
          .bottom-line {
            width: 100%;
          }
          a {
            color: #194189;
          }
        }
        &.nav-active {
          font-family: PingFang SC Medium;
        }
        a {
          color: #1d2129;
        }
        .bottom-line {
          height: 2px;
          width: 0;
          background-color: #194189;
          position: absolute;
          bottom: -19px;
          left: 50%;
          transform: translateX(-50%);
          transition: all 0.3s;
        }
      }
    }
    .head-btn {
      .workbench {
        color: #1d2129;
        margin-right: 40px;
        display: flex;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
          margin-right: 4px;
        }
      }
      .head-login {
        cursor: pointer;
        a {
          color: #1d2129;
          img {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
  }
  .head-logo {
    width: 158px;
    height: 44px;
    box-sizing: border-box;
    a {
      display: inline-block;
      height: 44px;
      img {
        // width: 100%;
        height: 100%;
      }
    }
  }
  .nav-list {
    display: flex;
    justify-content: center;
    flex: 1;
    .nav-item {
      font-family: PingFang SC;
      font-weight: 500;
      font-style: Medium;
      font-size: 16px;
      letter-spacing: 0px;
      margin-right: 40px;
      cursor: pointer;
      position: relative;
      a {
        color: #194189;
      }
      .bottom-line {
        height: 2px;
        width: 0;
        background-color: #194189;
        position: absolute;
        bottom: -29px; // 根据导航项高度微调（导航项高50px，bottom: -30px）
        left: 50%;
        transform: translateX(-50%);
        transition: all 0.3s;
      }
    }
  }
  .head-btn {
    display: flex;
    align-items: center;
    .head-user {
      .avatar-box {
        width: 38px;
        height: 38px;
        .avatar {
          width: 38px;
          height: 38px;
          border-radius: 50%;
        }
      }
    }
  }
}
.fixPostion {
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 96px;
  right: 20px;
  z-index: 999;
  // width: 72px;
  height: 201px;
  background-color: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  padding: 16px 20px;
  box-sizing: border-box;
  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
    &:nth-child(2) {
      border-top: 1px solid rgba(0, 0, 0, 0.05);
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
    .icon {
      width: 20px;
      height: 20px;
      &.icon-big {
        transform: scale(1.6);
      }
    }
    .text {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 10px;
      // line-height: 16px;
      letter-spacing: 0px;
      color: rgba(29, 33, 41, 1);
      margin-top: 8px;
    }
    .big-icon {
      width: 40px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 15px;
    }
  }
}
</style>
<style lang="scss">
.workbench-popper {
  width: 372px !important;
  &.el-popover {
    &.el-popper {
      border-radius: 12px;
      padding: 20px;
      .workbench-content {
        .userole-troggle {
          display: flex;
          align-items: center;
          cursor: pointer;
          span {
            color: #1c212a;
            font-family: 'PingFang SC';
            font-size: 12px;
            font-weight: 400;
          }
          img {
            width: 12px;
            height: 12px;
            margin-left: 4px;
          }
        }
        .workbench-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-top: 8px;
          .user-info {
            color: #1c212a;
            font-family: 'PingFang SC';
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
          }
          .main-btn {
            width: 108px;
            height: 32px;
            background-color: #1546f2;
            border-radius: 6px;
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 20px;
            cursor: pointer;
            span {
              color: #fff;
              font-size: 14px;
            }
            img {
              width: 20px;
              height: 20px;
            }
          }
        }
        .workbench-bottom {
          background-color: #f7f8fa;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-top: 20px;
          padding: 16px 12px 0;
          width: 332px;
          border-radius: 6px;
          .workbench-item {
            width: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            margin-bottom: 16px;
            img {
              width: 24px;
              height: 24px;
            }
            span {
              color: #1d2129;
              font-size: 14px;
              margin-top: 4px;
            }
          }
        }
      }
    }
  }
}
.user-info-popper {
  padding: 12px !important;
  &.el-popover {
    box-sizing: border-box;
    &.el-popper {
      border-radius: 12px;
      box-sizing: border-box;
      .menu-btn {
        display: flex;
        margin-bottom: 6px;
        position: relative;
        .split-line {
          background-color: rgba(29, 33, 41, 0.08);
          height: 40px;
          width: 2px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        .menu-btn-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          padding: 10px 17px;
          height: 68px;
          box-sizing: border-box;
          &:hover {
            span {
              color: #194189;
            }
            .icon {
              &.icon-admin {
                background-image: url(https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/3bf3151bd6804f75b77f19e68f13ae3e.png);
              }
            }
          }
          .icon {
            width: 24px;
            height: 24px;
            background-size: 100% 100%;
            &.icon-admin {
              background-image: url(https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/d74c525c1e2643ab81ba686f70c0ef6a.png);
            }
            &.icon-account {
              background-image: url(https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/3834874635d94e0da587592320c1dae0.png);
            }
          }
          span {
            color: #1d2129;
            font-size: 14px;
          }
        }
      }
      .menu-bottom-btn {
        background-color: #f7f8fa;
        height: 34px;
        width: 188px;
        color: #1d2129;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        line-height: 34px;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
  }
}
.user-role-popper {
  .user-role-list {
    .user-role-item {
      cursor: pointer;
      margin: 4px 0;
    }
  }
}
.hidemenu_drop {
  width: 130px;

  a {
    color: #000;

    &:hover {
      color: var(--el-color-primary);
    }
  }

  .el-dropdown-menu__item {
    text-align: center;
  }
}
.el-dropdown {
  line-height: inherit;
}
</style>
